export default function ZNoticeBanner({
	icon,
	title,
	children
}: {
	icon: string
	title: string
	children: React.ReactNode
}) {
	return (
		<div className='item_notice mgt-30lg mgt-50 mgl-0lg mgl-120'>
			<div className='item_notice_head'>
				<img src={icon} alt='Ikonka' height={29} width={29} />
				{title}
			</div>
			<div className='item_notice_text mt-4'>{children}</div>
		</div>
	)
}
